import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Navbar from "components/Navbar";

const Layout = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <Box component="main" sx={{ flex: 1, p: { xs: 1.5, sm: 3 } }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
